import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=8405bfb6&scoped=true&"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts&"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsMenu.vue?vue&type=style&index=0&id=8405bfb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8405bfb6",
  null
  
)

export default component.exports